<template>
    <div class="card-consultant">
        <CardHand class="card-consultant__hand" ms-theme>
            <PrismicImage :image="consultant.image" />
        </CardHand>
        <div>
            <div class="card-consultant__name">{{ consultant.name }}</div>
            <div class="card-consultant__job">{{ consultant.job }}</div>
            <div class="card-consultant__info">
                <strong>{{ consultant.title1 }}</strong>
                <p>{{ consultant.text1 }}</p>
                <strong v-if="consultant.title2">{{ consultant.title2 }}</strong>
                <p v-if="consultant.text2">{{ consultant.text2 }}</p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type {ConsultantProfilesSliceDefaultItem} from '@prismicio-types';
    import CardHand from '~/components/CardHand.vue';
    import PrismicImage from '~/components/PrismicImage.vue';

    defineProps<{consultant: ConsultantProfilesSliceDefaultItem}>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    $max_width: 440px;
    $card_width: 219px;
    $card_height: 274px;

    .card-consultant {
        margin: var(--joy-core-spacing-8) auto 0;
        text-align: center;
        padding: 0 var(--joy-core-spacing-12);
        border-radius: var(--joy-core-radius-4);
        // max-width: $max_width;

        &__hand {
            margin: 0 auto var(--joy-core-spacing-6);
            user-select: none;
        }
        &__info {
            margin: var(--joy-core-spacing-5) auto 0;
            max-width: 256px;

            strong {
                display: block;
                margin-top: var(--joy-core-spacing-4);
                color: var(--joy-color-secondary-30);
                font-size: var(--joy-font-size-primary-200);
                font-weight: var(--joy-font-weight-bold);
                text-transform: uppercase;
                letter-spacing: -0.12px;
                user-select: none;
            }
            p {
                margin-top: var(--joy-core-spacing-1);
                color: var(--joy-color-neutral-40);
                letter-spacing: -0.16px;
            }
        }
        &__name {
            font-family: var(--joy-font-family-title);
            color: var(--joy-color-text-title);
            font-size: var(--joy-font-size-secondary-200);
            line-height: var(--joy-line-height-small);
        }
        &__job {
            margin-top: var(--joy-core-spacing-2);
            color: var(--joy-color-neutral-40);
            font-size: var(--joy-font-size-primary-400);
            font-weight: var(--joy-font-weight-bold);
            letter-spacing: -0.16px;
            line-height: var(--joy-line-height-small);
        }
    }
</style>
